define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitDocTypeDomain = void 0;
    class PermitDocTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: PermitDocTypeDomain.Permit, value: "Permit" },
                    { key: PermitDocTypeDomain.PermitCancellationNotice, value: "Permit Cancellation Notice" },
                    { key: PermitDocTypeDomain.PermitRefusalNotice, value: "Permit Refusal Notice" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[PermitDocTypeDomain.Permit] = 0;
                this.KeyIndex[PermitDocTypeDomain.PermitCancellationNotice] = 1;
                this.KeyIndex[PermitDocTypeDomain.PermitRefusalNotice] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Permit"] = 0;
                this.ValueIndex["Permit Cancellation Notice"] = 1;
                this.ValueIndex["Permit Refusal Notice"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.PermitDocTypeDomain = PermitDocTypeDomain;
    Object.defineProperty(PermitDocTypeDomain, "Permit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(PermitDocTypeDomain, "PermitCancellationNotice", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(PermitDocTypeDomain, "PermitRefusalNotice", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(PermitDocTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
